import React, { useState, useEffect } from 'react';
import styles from './PopUp.module.css';

const Popup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup on every page load with a slight delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []); // Empty dependency array means it runs on every component mount

  const handleClose = () => {
    setIsVisible(false);
    // No need to store in sessionStorage anymore since we show every time
  };

  // Don't render if not visible
  if (!isVisible) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popup}>
        <div className={styles.popupHeader}>
          <h2 className={styles.importantNotice}>⚠️ आवश्यक सूचना / Important Notice</h2>
          <button className={styles.closeBtn} onClick={handleClose} aria-label="Close">×</button>
        </div>
        
        <div className={styles.popupContent}>
          <div className={styles.messageSection}>
            <h3>In English:</h3>
            <p>
              Due to change in Government Policy and Lending Policy, 
              we are not operational right now. We are adhering to policy change 
              and will resume operations once the regulatory framework is clear.
            </p>
          </div>

          <div className={styles.messageSection}>
            <h3>हिंदी में:</h3>
            <p>
              सरकारी नीति और उधार नीति में परिवर्तन के कारण, 
              हम फिलहाल परिचालन में नहीं हैं। हम नीति परिवर्तन का पालन कर रहे हैं 
              और एक बार नियामक ढांचा स्पष्ट होने के बाद ही परिचालन फिर से शुरू करेंगे।
            </p>
          </div>

          <div className={styles.footerNote}>
            <p>We appreciate your understanding and patience during this period.</p>
            <p>इस अवधि में आपकी समझ और धैर्य की सराहना करते हैं।</p>
          </div>
        </div>

        <div className={styles.popupFooter}>
          <button className={styles.acknowledgeBtn} onClick={handleClose}>
            I Understand / मैं समझ गया
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;